import { render, staticRenderFns } from "./ChipsStatus.vue?vue&type=template&id=261a1cae"
import script from "./ChipsStatus.vue?vue&type=script&lang=js"
export * from "./ChipsStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports